import '.cb{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.iw{padding:0.6rem;}.ssr-plugin'
import '.ix{border-radius:1.875rem;}.ssr-plugin'
import '.iy{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.iz{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.dj{border-radius:2rem;}.ssr-plugin'
import '.j0{overflow-x:hidden;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import '.j1{background:var(--page-bg);}.ssr-plugin'
import '.ao{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cb e t v iw ix iy iz"
      style={{
        ...style,
      }}
    >
      <styled.div className="dj j0 c5 j1 ao"
        style={{
          width,
          height,}}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
